import SvgIcon from "@/components/SvgIcon"; // svg component
import Vue from "vue";

// register globally
Vue.component("SvgIcon", SvgIcon);

const req = require.context("./svg", true, /\.svg$/);
const requireAll = (requireContext) =>
  requireContext.keys().map(requireContext);
requireAll(req);
